import { IState } from '@pvolve/sdk/src/redux/selectors';

export default {
    root: (state: IState) => state.partner,
    current: (state: IState) => state.partner.current,
    loading: (state: IState) => state.partner.loading,
    error: (state: IState) => state.partner.error,
};
